import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Route } from '@angular/router';

//third party
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Own modules
import * as AngularCore from '@lmnop/angular-core';

import { SettingsStorageBase } from '@lmnop/web-core';
import { ExtendedCookieService } from './ioc/implementation/extended-cookie-service/extended-cookie-service.class';
import { PrivacyPolicyPage } from './components/page-components/privacy-policy/privacy-policy.page';
import { CookiePolicyPage } from './components/page-components/cookie-policy/cookie-policy.page';
import { UninstallPage } from './components/extension-website-page-components/uninstall/uninstall.page';
import { CookieConsentControl } from './components/control-components/cookie-consent/cookie-consent.control';
import { SubscribeWecdevControl } from './components/control-components/subscribe-wecdev/subscribe-wecdev.control';
import { BackgroundControl } from './components/control-components/background/background.control';
import { UninstallDonationModal } from './components/extension-website-page-components/uninstall/uninstall-donation.modal';

// const TRANSLATE_FILES_DIRECTORY_PATH: string = '/_angular_deploy/' + SettingsStorageBase.V_VERSION_SNAKE_CASE + '/_locales/';
const TRANSLATE_FILES_DIRECTORY_PATH: string = '/_locales/';

const PUBLIC_ANGULARWEBSITEMODULE_DECLARATIONS: any[] = [
    CookieConsentControl,
    SubscribeWecdevControl,

    CookiePolicyPage,
    PrivacyPolicyPage,
    BackgroundControl,
    UninstallPage,
    UninstallDonationModal,
];

@NgModule({
    imports: [
        FormsModule,
        TranslateModule,
        BrowserAnimationsModule,
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        // Own modules
        AngularCore.AngularCoreModule,
    ],
    declarations: [PUBLIC_ANGULARWEBSITEMODULE_DECLARATIONS],
    exports: [PUBLIC_ANGULARWEBSITEMODULE_DECLARATIONS],
    providers: [
        ExtendedCookieService,
        {
            provide: AngularCore.TRANSLATE_FILES_DIRECTORY__INJECTION_TOKEN,
            useValue: TRANSLATE_FILES_DIRECTORY_PATH,
        },
    ],
})
export class AngularWebsiteCoreModule {}

// required for AOT compilation
export function WebsiteHttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, TRANSLATE_FILES_DIRECTORY_PATH);
}

export const CommonRoutes: Route[] = [
    { path: 'privacyPolicy', component: PrivacyPolicyPage },
    { path: 'cookiePolicy', component: CookiePolicyPage },
];

export const ExtensionWebsiteRoutes: Route[] = [{ path: 'uninstall', component: UninstallPage }];

export function setAngularWebsiteCoreModuleNavbar(url: string, navbarControl: AngularCore.NavbarControl): void {
    if (url.toLowerCase().includes('cookiepolicy')) {
        navbarControl.items = [
            new AngularCore.SiteUrlNavigateNavbarItem('return_to_home', 'home'),
            new AngularCore.SiteUrlNavigateNavbarItem('privacy_policy', 'privacyPolicy'),
        ];
    }
    if (url.toLowerCase().includes('privacypolicy')) {
        navbarControl.items = [
            new AngularCore.SiteUrlNavigateNavbarItem('return_to_home', 'home'),
            new AngularCore.SiteUrlNavigateNavbarItem('cookie_policy', 'cookiePolicy'),
        ];
    }
    if (url.toLowerCase().includes('uninstall')) {
        navbarControl.items = [new AngularCore.SiteUrlNavigateNavbarItem('return_to_home', 'home')];
    }
}

//ioc
export * from './ioc/ioc.keys.class';
export * from './ioc/implementation/angular-website-core-ioc-container/angular-website-core-ioc-container.interface';
export * from './ioc/implementation/angular-website-core-ioc-container/angular-website-core-ioc-container.class';

export * from './ioc/implementation/extended-cookie-service/extended-cookie-service.interface';
export * from './ioc/implementation/extended-cookie-service/extended-cookie-service.class';

//components
export * from './components/control-components/cookie-consent/cookie-consent.control';
export * from './components/control-components/subscribe-wecdev/subscribe-wecdev.control';
export * from './components/control-components/background/background.control';

export * from './components/page-components/cookie-policy/cookie-policy.page';
export * from './components/page-components/privacy-policy/privacy-policy.page';

export * from './components/extension-website-page-components/uninstall/uninstall.page';
export * from './components/extension-website-page-components/uninstall/uninstall-donation.modal';
